export default __webpack_public_path__ + "static/media/crypo-paper.af0cfc2d.png";